import constants from 'src/constants';

const { PROPERTY_TYPE } = constants.property;

/**
 * Convert deliverable id to property type
 * @param {number} deliverableId
 * @returns {string} The measurement type
 */
const getPropertyTypeName = (deliverableId) => {
  const propertyKey = Object.keys(PROPERTY_TYPE).find((key) => {
    return PROPERTY_TYPE[key].deliverableId === deliverableId;
  });
  return propertyKey ? PROPERTY_TYPE[propertyKey].name : 'Unknown';
};

/**
 * @param {number} deliverableId
 * @returns {bool}
 */
const isRoofOnly = (deliverableId) => {
  return deliverableId === PROPERTY_TYPE.roof_only.deliverableId;
};

export default {
  getPropertyTypeName,
  isRoofOnly,
};
